import {
    getDetailedMeasureName,
    getMeasureDisplayNameByKey,
    getMeasureNameByKey,
} from '../shared/measureUtils';
import { getMainHelpUrl, URL } from '../../constants/reading/ApiConstants';
import { MEASURE, PARENT_MEASURE, ALL_MEASURES } from '../../constants/reading/MeasuresConstants';

const { ORF, ORF_ACC, OL, NWF_CLS, NWF_WRC, TRO, DO, VOCABO, SPELLING, RAN } = MEASURE;
const { ORF_OVERALL } = PARENT_MEASURE;

export const getProbeDetailsAssessmentName = measure => {
    return getDetailedMeasureName(ALL_MEASURES, measure === ORF ? ORF_OVERALL : measure);
};

export const getProbeDetailsOverallScore = ({ score, maxScore, interp }) =>
    maxScore && interp ? `${score}/${maxScore}, ${interp.replace('-', ' ')}` : '';

export const getProbeDetailsMeasureName = measure => {
    if (measure === ORF || measure === ORF_ACC || measure === SPELLING)
        return getMeasureDisplayNameByKey(ALL_MEASURES, measure);
    if (measure === NWF_CLS || measure === NWF_WRC)
        return `${getMeasureDisplayNameByKey(ALL_MEASURES, measure)} (${
            measure === NWF_CLS ? 'CLS' : 'WRC'
        })`;
    return getDetailedMeasureName(ALL_MEASURES, measure);
};

export const getProbeDetailsHelpUrl = (measure, licensingInfo) => {
    switch (measure) {
        case TRO:
            return `${URL.TRO.TRO_HELP_URL}D_TRO`;
        case DO:
            return `${URL.DECODING.DECODING_HELP_URL}D_DO`;
        case VOCABO:
            return `${URL.VOCABO.VOCABO_HELP_URL}PD`;
        case SPELLING:
            return `${URL.SPELLING.SPELLING_HELP_URL}PD`;
        case RAN:
            return `${URL.RAN.RAN_HELP_URL}PD`;
        case OL:
            return `${URL.OL.OL_HELP_URL}D_OL`;
        default:
            return `${getMainHelpUrl(licensingInfo)}D_${getMeasureNameByKey(
                ALL_MEASURES,
                measure,
            )}`;
    }
};
